var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37109 5.56641C6.70117 5.87109 6.70117 6.4043 6.37109 6.70898L1.49609 11.584C1.19141 11.9141 0.658203 11.9141 0.353516 11.584C0.0234375 11.2793 0.0234375 10.7461 0.353516 10.4414L4.64453 6.125L0.353516 1.83398C0.0234375 1.5293 0.0234375 0.996094 0.353516 0.691406C0.658203 0.361328 1.19141 0.361328 1.49609 0.691406L6.37109 5.56641Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow_right.63a5cc1e2badea0e8ed60202ac7a7190.svg";
export { ForwardRef as ReactComponent };